import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchModule, type ChannelsEnvelope, type ModuleFilters } from '../api/events';

/**
 * Stable query key for the Events → Channels module envelope. Exported
 * so sibling code (e.g. an invalidator after an ingest) can refer to
 * the same key without re-deriving it.
 */
export function eventsChannelsKey(filters?: ModuleFilters) {
  return ['events', 'channels', filters ?? {}] as const;
}

/**
 * Fetch the Events → Channels envelope: per-channel signups +
 * conversion + anomaly flag, with `meta.anomalies` carrying the
 * transform-layer broken-funnel detections.
 *
 * Returns the full envelope so consumers can render `<Freshness/>`,
 * `<Denominator/>`, and `<AnomalyChip/>` alongside the leaderboard.
 */
export function useEventsChannels(
  filters?: ModuleFilters,
): UseQueryResult<ChannelsEnvelope, Error> {
  return useQuery({
    queryKey: eventsChannelsKey(filters),
    queryFn: ({ signal }) => fetchModule('channels', filters, { signal }),
    staleTime: 5 * 60 * 1000,
  });
}
